module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-from-top-c1a70ea4fa2f1b4f063e47eb27b7bba5.svg";